<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <card>
        <div
          class="col-md-12 col-lg-12 col-sm-12"
          role="dialog"
          aria-labelledby="modalTitle"
          aria-describedby="modalDescription"
        >
          <div class="modal-body">
            <div>
              <h4
                slot="header"
                id="modalTitle"
                class="card-title mb-3 text-align-center"
              >
                {{ titulo }} Concessionária
              </h4>

              <form id="modalDescription">
                <div class="row pl-3">
                  <base-input
                    type="text"
                    label="Nome"
                    v-model="concessionaria.nome"
                    @input="validaCampos()"
                    @change="validaCampos()"
                  ></base-input>
                </div>

                <hr />
                <div class="text-center mt-4">
                  <button
                    type="submit"
                    class="btn btn-success btn-fill float-right"
                    @click.prevent="salvar"
                    :disabled="erroValidacao"
                  >
                    <i class="fa fa-floppy-o" aria-hidden="true"></i> Salvar
                  </button>
                  <button
                    @click.prevent
                    class="btn btn-danger btn-fill float-left"
                    @click="close"
                  >
                    <i class="fa fa-times" aria-hidden="true"></i> Fechar
                  </button>
                </div>
                <div class="clearfix"></div>
              </form>
            </div>
          </div>
        </div>
      </card>
    </div>
  </transition>
</template>

<script>
import Card from 'src/components/Cards/Card.vue';
import ConcessionariasService from 'src/services/concessionarias';
import _ from 'lodash';

const VUE_APP_SPINNER_COLOR = process.env.VUE_APP_SPINNER_COLOR;

export default {
  components: {
    Card
  },
  props: {
    afterCreateAction: Function,
    action: String,
    concessionaria: {
      type: Object,
      default: () => ({ _id: null, nome: '' })
    }
  },
  data() {
    return {
      erroValidacao: true
    };
  },
  computed: {
    titulo() {
      if (this.action === 'EDIT') {
        return 'Editar';
      }
      if (this.action === 'NEW') {
        return 'Cadastrar';
      }
      return '';
    }
  },
  methods: {
    validaCampos() {
      const nome = (this.concessionaria.nome || '').trim();
      this.erroValidacao = !nome;
    },
    salvar() {
      const nome = (this.concessionaria.nome || '').trim();
      if (!nome) return;

      const loader = this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });

      const successCallback = () => {
        this.notifyVue(
          'top',
          'center',
          'success',
          'Salvo com sucesso.',
          'fa fa-check'
        );
        if (this.afterCreateAction) this.afterCreateAction();
        this.close();
        loader.hide();
      };

      const errorCallback = err => {
        const message =
          _.get(err, 'response.status') === 400 &&
          _.has(err, 'response.data.message')
            ? _.get(err, 'response.data.message')
            : 'Ocorreu algum erro interno. Tente novamente mais tarde.';
        this.notifyVue(
          'top',
          'center',
          'danger',
          message,
          'fa fa-exclamation-triangle'
        );
        loader.hide();
      };

      if (this.concessionaria._id) {
        ConcessionariasService.atualizar({
          _id: this.concessionaria._id,
          nome
        })
          .then(successCallback)
          .catch(errorCallback);
      } else {
        ConcessionariasService.salvar({ nome })
          .then(successCallback)
          .catch(errorCallback);
      }
    },
    close() {
      this.$emit('close');
    },
    notifyVue(verticalAlign, horizontalAlign, type, message, icon) {
      this.$notifications.notify({
        message: `<span>${message}.</span>`,
        icon: icon,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type
      });
    }
  },
  watch: {
    concessionaria: {
      handler() {
        this.validaCampos();
      },
      deep: true
    }
  }
};
</script>
<style scoped>
.modal-fade-enter,
.modal-fade-leave-active {
  opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.5s ease;
}
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

#modalDescription {
  width: 350px;
}

.modal-body {
  position: relative;
}

.form-group {
  width: 100%;
}
</style>
